/* eslint-disable */
import DatePickerDateTime from '@/components/common/date/DatePickerDateTime';
import Loader from '@/components/common/Loader';
import { useMessageSend } from '@/components/hooks/customs/addressBook/useMessageSend';
import { useMessageSender } from '@/components/hooks/customs/addressBook/useMessageSender';
import { useWindowPopup } from '@/components/hooks/customs/windowPopup/useWindowPopup';
import SendMsgByte from '@/components/softPhone/commons/SendMsgByte';
import MessageSendImgModal from '@/components/softPhone/DisplayGroups/MessageSend/components/MessageSendImgModal';
import MessageSendInfo from '@/components/softPhone/DisplayGroups/MessageSend/components/MessageSendInfo';
import { useMessageSendPublishHook } from '@/components/softPhone/DisplayGroups/MessageSend/useMessageSendPublishHook';
import { mainTableCheckDataFormatRecoil } from '@/recoil/atoms/mainTableRecoil';
import {
  mobileNavRecoil,
  softPhoneRowTabRecoil,
  softPhoneTopTabRecoil,
  windowWidthRecoil,
} from '@/recoil/atoms/router/mainRouterRecoil';
import { calMsgByte } from '@/shared/util/byteCalculatorUtil';
import React, { useEffect, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { v4 as uuidv4 } from 'uuid';
import { useAddresseeNotify } from '../../../hooks/customs/messageSend/useAddresseeNotify';
import MessageAddNotify from './components/MessageAddNotify';
import SaveMessageBtn from './components/saveMessage/SaveMessageBtn';
import * as S from './MessageSend.styles';
import { FaAd, FaClock, FaPlus, FaRegAddressBook, FaRegImage } from 'react-icons/fa';
import AdNoticeModal from '@/pages/main/components/modal/customModal/AdNoticeModal';
import { adTextFirstToggleRecoil } from '@/recoil/atoms/messageSend/messageSend';
import { IoCloseSharp } from 'react-icons/io5';
import SearchReceiverList from './components/SearchReceiverList';
import { formatPhoneNumber, TelHyphen } from '@/shared/util/format/phoneNumberFormatUtil';

/**ToggleSaveMessage
 * @title 소프트폰에 '문자 전송하기' 또는 '문자 예약하기' 버튼 클릭시 소프트폰 표출되는 컴포넌트
 * */
const MessageSend = () => {
  const mainTableCheckDataFormatS = useRecoilValue(mainTableCheckDataFormatRecoil);
  const softPhoneTopTab = useRecoilValue(softPhoneTopTabRecoil);

  const softPhoneRowTabState = useRecoilValue(softPhoneRowTabRecoil);
  // publish hook
  const publishHook = useMessageSendPublishHook();
  //  custom hook
  const { selectNumber, fomatCallingNum } = useMessageSender();
  const hooks = useMessageSend({ selectNumber, fomatCallingNum });
  const popupHooks = useWindowPopup();

  const notiHooks = useAddresseeNotify({
    messageSendPhoneNumberState: hooks.messageSendPhoneNumberState,
    mainTableCheckDataFormatS: mainTableCheckDataFormatS,
  });

  const windowWidth = useRecoilValue(windowWidthRecoil);
  const [mobileNavState, setMobileNavState] = useRecoilState(mobileNavRecoil);

  // 수신인 리스트 화살버튼 표시
  const [arrowOpen, setArrowOpen] = React.useState<boolean>(false);
  // 광고 버튼 한번이라도 끄면 전송 전까지 다시 안뜨게
  const adTextFirstToggleS = useRecoilValue(adTextFirstToggleRecoil);

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);

  const searchRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior: 'smooth', // 스크롤이 부드럽게 이동
      });
    }
  }, [hooks.messageSendPhoneNumberState, mainTableCheckDataFormatS]);

  // 수신인
  useEffect(() => {
    // 직접 추가 수신인
    const phoneNumberLength = hooks.messageSendPhoneNumberState ? hooks.messageSendPhoneNumberState.length : 0;
    // 선택 그룹 내 수신인
    const groupListCountLength = mainTableCheckDataFormatS
      ? mainTableCheckDataFormatS.reduce((acc, obj) => acc + obj.count, 0)
      : 0;
    // 수신인 길이
    const totalCount = phoneNumberLength + groupListCountLength;

    if (totalCount > 1 && !hooks.adMessageS) {
      // 화살표버튼 토글
      setArrowOpen(true);
      // 수신인 2명 이상이고 전송 후 처음일 때 광고 자동 추가
      if (adTextFirstToggleS) {
        hooks.adMessageHandler();
      }
    } else {
      setArrowOpen(false);
    }
  }, [hooks.messageSendPhoneNumberState, mainTableCheckDataFormatS]);

  // TODO - 주소록 체크박스 여기 mainTableCheckDataFormatS값 확인

  // 수신인 검색기능 추가하는 곳

  return (
    <S.MessageSend className="messageSend">
      {hooks.modalToggleS && <AdNoticeModal onClickModalClose={hooks.adMessageHandler} />}
      <S.MessageSendWrap className="MessageSendWrap">
        <S.MessageSendGroup>
          {hooks.sendMsgLoading && <Loader backgroundToggle />}
          {/* 중복 제거 알림 */}
          {notiHooks.addList && notiHooks.notifyToggle && windowWidth > 768 && <MessageAddNotify notiType={'add'} />}
          {/* 수신인 리스트 */}
          <S.RecipientsList className={`${publishHook.liVisibilities.buttonActive ? 'active' : ''}`}>
            <S.AddressAdd className={`addressAdd ${publishHook.formToggle ? 'active' : ''}`}>
              <div ref={searchRef}>
                {publishHook.formToggle && (
                  <form
                    onSubmit={(e) => {
                      // buddyNameIsLoading이 true일 경우 폼 제출을 막음
                      if (hooks.buddyNameIsLoading) {
                        e.preventDefault(); // 폼 제출을 막음
                        return;
                      }
                      hooks.addEtcList(e);
                    }}
                  >
                    <label htmlFor="recipients">
                      <input
                        type="text"
                        placeholder="수신번호 입력"
                        value={hooks.etcInputValueState}
                        maxLength={13}
                        onChange={(e) => hooks.etcInputHandler(e.currentTarget.value)}
                      />
                      <button className="etc-list-button" type="submit">
                        <FaPlus />
                        <p>추가</p>
                      </button>
                    </label>
                  </form>
                )}
                <SearchReceiverList
                  etcInputValueState={hooks.etcInputValueState}
                  setEtcInputValueState={hooks.setEtcInputValueState}
                  addEtcList={hooks.addEtcList}
                  searchRef={searchRef}
                />
              </div>
              {hooks.reSendMsgToggleState && (
                <S.Toggle onClick={hooks.onClickAddressToggle}>
                  <button className={hooks.addressOpenToggleState ? 'active' : ''}>
                    {hooks.addressOpenToggleState ? '주소록 닫기' : '주소록 열기'}
                  </button>
                </S.Toggle>
              )}
              <S.RecipientsGroup
                ref={scrollContainerRef}
                className={`recipientsGroup ${publishHook.listBoxToggle ? 'active' : ''}`}
              >
                <ol className={`recipients ${publishHook.liVisibilities.buttonActive ? 'active' : ''}`}>
                  {/* 직접 추가 수신인 목록 */}
                  {hooks.messageSendPhoneNumberState &&
                    hooks.messageSendPhoneNumberState.map((item) => (
                      <li className={publishHook.activeTag === 'etcSend' ? 'active' : ''} key={uuidv4()}>
                        <div className="smallContents">
                          <div className="recipientTitle" role="button">
                            <p>
                              수신인 : <span>{formatPhoneNumber(item.phoneNumber)}</span>
                            </p>
                          </div>
                          <div className="state">
                            <p className="name">{item.buddyNm && `(${item.buddyNm})`}</p>
                            <S.BtnWhiteGray>
                              <button
                                className="eraseButton"
                                onClick={() => hooks.deleteSendBottomEtcList(item.phoneNumber)}
                              >
                                <IoCloseSharp />
                              </button>
                            </S.BtnWhiteGray>
                          </div>
                        </div>
                      </li>
                    ))}

                  {/* 그룹 수신인 */}
                  {mainTableCheckDataFormatS &&
                    mainTableCheckDataFormatS.map((item) => {
                      if (!(item.count > 0)) return null;
                      return (
                        <li
                          key={uuidv4()}
                          className={`${hooks.activeGroupState?.groupSeqNo === item.groupSeqNo ? 'active' : ''}`}
                        >
                          <div
                            className="smallContents"
                            onClick={() => hooks.onClickGroupList(item.groupSeqNo, item.groupNm)}
                          >
                            <div className={`recipientTitle`} role="button">
                              <p>
                                수신그룹 : <span>{item?.groupNm}</span>
                              </p>
                            </div>
                            <div className="state">
                              <p className="countNum">&#40;{item.count}명&#41;</p>
                              <S.BtnWhiteGray>
                                <button
                                  className="eraseButton"
                                  onClick={(e) => {
                                    hooks.deleteSendTopList(item.groupSeqNo);
                                    e.stopPropagation();
                                  }}
                                >
                                  <IoCloseSharp />
                                </button>
                              </S.BtnWhiteGray>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                </ol>
              </S.RecipientsGroup>
            </S.AddressAdd>
          </S.RecipientsList>

          {/* 전송내용 */}
          <S.Transmissiondetails
            subjectBoolean={
              (calMsgByte(hooks.sndMsgState) > (hooks.adMessageS ? 55 : 90) || hooks.fileResult) &&
              fomatCallingNum !== '015'
            }
          >
            {/* <div className="flexBox"> */}
            <div className="SendTextBox">
              {/* 010 일때 LMS 제목 */}
              {(calMsgByte(hooks.sndMsgState) > (hooks.adMessageS ? 55 : 90) || hooks.fileResult) &&
                fomatCallingNum !== '015' && (
                  <div className="titleGroup">
                    <p>제목 : </p>
                    <input
                      type="text"
                      value={hooks.sndMsgSubjectState}
                      placeholder={'제목을 입력해주세요.(최대 20byte)'}
                      onChange={hooks.msgSubjectHandler}
                    />
                  </div>
                )}

              {/* 광고 알림 */}
              {/* {hooks.adMessageS && (
                <div className="adGroup">
                  <button
                    type="button"
                    className="adNotice"
                    onClick={() => popupHooks.openPopup({ url: '/adNoticeContent', target: '_blank', size: '2' })}
                  >
                    !
                  </button>
                  <button type="button" onClick={hooks.adMessageHandler}>
                    광고 제거
                  </button>
                </div>
              )} */}

              {/* 내용 */}
              <div className="sendContentGroup">
                {hooks.fileResult ? (
                  <div className="sendImage">
                    <div className="imgBox" onClick={hooks.onClickSendImgToggle}>
                      {
                        /* 재전송 파일이 있으면서 input 파일 delete 버튼 안눌렀을 경우 */
                        hooks.reSendFileState && !hooks.fileDeleteToggle ? (
                          <>
                            {/* 재전송 - API 요청으로 받아온 바이너리 데이터 표출 */}
                            <img className={'onImage'} src={`data:image/jpeg;base64,${hooks.fileResult}`} alt="" />
                          </>
                        ) : (
                          <>
                            {/* INPUT 이미지 업로드로 이미지 표출 */}
                            {hooks.fileState &&
                              (() => {
                                const { type, name } = hooks.fileState;

                                // 파일 미리보기
                                if (type.startsWith('image/')) {
                                  return <img className="onImage" src={hooks.fileResult} alt={hooks.fileState.name} />;
                                }
                                if (type.startsWith('video/')) {
                                  return <video controls src={hooks.fileResult} />;
                                }
                                if (type.startsWith('audio/')) {
                                  return <audio controls src={hooks.fileResult} />;
                                }
                                return <div className="fileName">{name}</div>; // 파일 타입이 지원되지 않는 경우
                              })()}
                          </>
                        )
                      }
                    </div>
                    <button className="deleteButton" onClick={hooks.deleteInputFile}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                        <path
                          d="M6.82843 6.82854C6.76592 6.89106 6.68113 6.92617 6.59272 6.92617C6.50432 6.92617 6.41953 6.89106 6.35702 6.82854L4 4.47152L1.64298 6.82854C1.58047 6.89106 1.49568 6.92617 1.40728 6.92617C1.31887 6.92617 1.23408 6.89106 1.17157 6.82854C1.10906 6.76603 1.07394 6.68125 1.07394 6.59284C1.07394 6.50444 1.10906 6.41965 1.17157 6.35714L3.5286 4.00012L1.17157 1.64309C1.10906 1.58058 1.07394 1.4958 1.07394 1.40739C1.07394 1.31899 1.10906 1.2342 1.17157 1.17169C1.23408 1.10918 1.31887 1.07406 1.40728 1.07406C1.49568 1.07406 1.58047 1.10918 1.64298 1.17169L4 3.52871L6.35702 1.17169C6.41953 1.10918 6.50432 1.07406 6.59272 1.07406C6.68113 1.07406 6.76592 1.10918 6.82843 1.17169C6.89094 1.2342 6.92606 1.31899 6.92606 1.40739C6.92606 1.4958 6.89094 1.58058 6.82843 1.64309L4.4714 4.00012L6.82843 6.35714C6.89094 6.41965 6.92606 6.50444 6.92606 6.59284C6.92606 6.68125 6.89094 6.76603 6.82843 6.82854Z"
                          fill="#FDFDFD"
                          stroke="#FDFDFD"
                          strokeWidth="0.5"
                        />
                      </svg>
                    </button>
                  </div>
                ) : null}

                {hooks.adMessageS && (
                  <div className="freeRefusal">
                    {/* <button
                      type="button"
                      className="adNotice"
                      onClick={() => popupHooks.openPopup({ url: '/adNoticeContent', target: '_blank', size: '2' })}
                    >
                      !
                    </button> */}
                    <p>{'(광고)'}</p>
                  </div>
                )}

                <textarea
                  className={hooks.adMessageS ? 'active' : ''}
                  name="comment"
                  value={hooks.sndMsgState}
                  // placeholder="전송할 메시지를 입력해주세요"
                  placeholder={
                    hooks.adMessageS
                      ? "(광고) 우측부터 내용이 입력되고, 업체명은 '(광고) 업체명' 과 같이 (광고) 바로 뒤에 작성해 주세요."
                      : '전송할 메시지를 입력해주세요'
                  }
                  ref={hooks.textareaRef}
                  onChange={(event) => {
                    hooks.handleSendMsg(event); // 이벤트 핸들러 호출
                    // hooks.handleResizeHeight();
                  }}
                  onInput={hooks.handleResizeHeight}
                />

                {hooks.adMessageS && (
                  <div className="freeRefusal">
                    <p>무료거부0801564706</p>
                  </div>
                )}
              </div>
              {/* 무료 거부 */}
            </div>
            {/* </div> */}
          </S.Transmissiondetails>
          {/* 이미지 첨부, 예약, 전송 */}
          {/* <S.AddresContentGroup maxByte={calMsgByte(hooks.sndMsgState) < hooks.byteS}> */}

          <S.ButtonContainer>
            {/* 예약 문자 활성화 출력될 컴포넌트 */}
            {hooks.clockToggleS && softPhoneTopTab === '1' && (
              <DatePickerDateTime onChange={hooks.handleDate} sndDttm={hooks.sndDttm} />
            )}
            <S.ButtonList>
              {/* 파일 추가 버튼 */}
              <S.ButtonItem title="파일 첨부">
                <input
                  type="file"
                  id={'fileUpload'}
                  ref={hooks.fileInputRef}
                  onChange={hooks.onChangeUploadImg}
                  accept=".jpg, .jpeg"
                  style={{ display: 'none' }}
                />
                <button
                  className={`file ${hooks.fileResult ? 'active' : ''}`}
                  type="button"
                  onClick={hooks.onClickInputFile}
                >
                  <FaRegImage />
                  <div>포토 문자</div>
                </button>
              </S.ButtonItem>

              {/* 광고버튼 */}
              <S.ButtonItem>
                <button
                  className={`ad ${hooks.adMessageS ? 'active' : ''}`}
                  type={'button'}
                  onClick={hooks.adMessageHandler}
                >
                  <FaAd />
                  <div>광고 {`${hooks.adMessageS ? '제거' : '표기'}`} </div>
                </button>
              </S.ButtonItem>

              {/* 메세지 저장 버튼 */}
              <S.ButtonItem>
                <SaveMessageBtn />
              </S.ButtonItem>

              {/* 예약날짜 */}
              {softPhoneRowTabState === '0' && softPhoneTopTab === '1' && (
                <S.ButtonItem>
                  <button
                    title="예약 전송 설정"
                    className={`iconBtn dateTable ${hooks.clockToggleS && 'active'}`}
                    onClick={() => hooks.setClockToggleS((prev) => !prev)}
                  >
                    <FaClock />
                    <div>예약 문자</div>
                  </button>
                </S.ButtonItem>
              )}

              {/* 바이트 표시 */}
              {fomatCallingNum === '015' && (
                <S.ButtonItem>
                  <SendMsgByte
                    sndMsg={hooks.sndMsgState || ''}
                    file={hooks.fileResult}
                    phoneType={'015'}
                    adMessage={hooks.adMessageS}
                    byteS={hooks.byteS}
                    setByteS={hooks.setByteS}
                    msgTypeS={hooks.msgTypeS}
                    setMsgTypeS={hooks.setMsgTypeS}
                    styleType="a"
                  />
                </S.ButtonItem>
              )}
              {fomatCallingNum === '010' && (
                <S.ButtonItem>
                  <SendMsgByte
                    sndMsg={hooks.sndMsgState || ''}
                    file={hooks.fileResult}
                    phoneType={'010'}
                    adMessage={hooks.adMessageS}
                    byteS={hooks.byteS}
                    setByteS={hooks.setByteS}
                    msgTypeS={hooks.msgTypeS}
                    setMsgTypeS={hooks.setMsgTypeS}
                    styleType="a"
                  />
                </S.ButtonItem>
              )}
            </S.ButtonList>
            <div className="byteSend">
              {/* 메세지 발송 버튼 */}
              {/* testCode수정 */}
              <S.MessageSendButton title="전송">
                <MessageSendInfo
                  sndDttm={hooks.sndDttm}
                  handleDate={hooks.handleDate}
                  repeatCycle={publishHook.repeatCycle}
                  repeatDay={publishHook.repeatDay}
                  toggleHand1={publishHook.toggleHand1}
                  tab={publishHook.tab}
                  setBottModalSwitch={publishHook.setBottModalSwitch}
                  setTab={publishHook.setTab}
                  sendMsgLoading={hooks.sendMsgLoading}
                  // ******************

                  onClickSend={hooks.onClickSend}
                  sndMsgState={hooks.sndMsgState}
                  fileResult={hooks.fileResult}
                  onClickSendValidation={hooks.onClickSendValidation}
                  softPhoneRowTabState={softPhoneRowTabState}
                />
              </S.MessageSendButton>

              {/* testCode수정 요거 삭제하면됌 */}
              {/* {fomatCallingNum !== '015' && (
                <S.SendButtonGroup title="전송">
                  <MessageSendInfo
                    sndDttm={hooks.sndDttm}
                    handleDate={hooks.handleDate}
                    repeatCycle={publishHook.repeatCycle}
                    repeatDay={publishHook.repeatDay}
                    toggleHand1={publishHook.toggleHand1}
                    tab={publishHook.tab}
                    onClickSendValidation={hooks.onClickSendValidation}
                    setBottModalSwitch={publishHook.setBottModalSwitch}
                    setTab={publishHook.setTab}
                    onClickSend={hooks.onClickSend}
                    softPhoneRowTabState={softPhoneRowTabState}
                    fileResult={hooks.fileResult}
                    sndMsgState={hooks.sndMsgState}
                  />
                </S.SendButtonGroup>
              )} */}
            </div>
          </S.ButtonContainer>
        </S.MessageSendGroup>
      </S.MessageSendWrap>

      {/* 이미지 팝업 */}
      {hooks.fileResult && hooks?.fileModal && (
        <MessageSendImgModal
          fileResult={hooks.fileResult}
          onClickSendImgToggle={hooks.onClickSendImgToggle}
          setFileModal={hooks.setFileModal}
          reSendFileState={hooks.reSendFileState}
        />
      )}
    </S.MessageSend>
  );
};

export default MessageSend;
